import React, { Component } from 'react'
import "./ResourcesFooter.scss";
import ReactSVG from 'react-svg';

export class ResourcesFooter extends Component {
  render() {
    return (
      <div className="ResourcesFooter">
        <div className="ResourcesFooter-content">
          <div className="ResourcesFooter-copy">© Copyright Absa Group 2019. All rights reserved.</div>

          <div className="ResourcesFooter-assoc">
            <div className="ResourcesFooter-copy">In association with</div>
            <div className="ResourcesFooter-logo"><ReactSVG src="./assets/made-for-humans.svg" /></div>
            <div className="ResourcesFooter-logo"><ReactSVG src="./assets/abacus-logo.svg" /></div>
          </div>
          <div className="ResourcesFooter-copy">Made with love by FT & ARO</div>
        </div>
      </div>
    )
  }
}
